import React from 'react';
type Trigger = 'bored' | 'lonely' | 'angry' | 'stressed' | 'tired' | 'other';
interface BlastoScreenProps {
  onSelectTrigger: (trigger: Trigger) => void;
}
export function BlastoScreen({
  onSelectTrigger
}: BlastoScreenProps) {
  return <main className="flex flex-col px-5 pt-10 pb-32 min-h-screen" data-id="element-21">
      {/* Header */}
      <div className="text-center mb-8" data-id="element-22">
        <h1 className="text-2xl font-bold text-foreground mb-3" data-id="element-23">
          What are you feeling right now?
        </h1>
        <p className="text-base text-muted-foreground leading-relaxed" data-id="element-24">
          Take a breath. You're here, and that's what matters.
        </p>
      </div>

      {/* BLASTO Grid */}
      <div className="grid grid-cols-2 gap-3" role="group" aria-label="Select what you're feeling" data-id="element-25">
        <button onClick={() => onSelectTrigger('bored')} className="bg-card border border-border rounded-lg p-5 min-h-[88px] flex flex-col items-center justify-center gap-2 hover:border-primary/50 active:border-primary active:bg-highlight/20 transition-all duration-150" aria-label="I'm feeling bored" data-id="element-26">
          <span className="text-3xl" role="img" aria-hidden="true" data-id="element-27">
            😐
          </span>
          <span className="font-medium text-foreground" data-id="element-28">Bored</span>
        </button>

        <button onClick={() => onSelectTrigger('lonely')} className="bg-card border border-border rounded-lg p-5 min-h-[88px] flex flex-col items-center justify-center gap-2 hover:border-primary/50 active:border-primary active:bg-highlight/20 transition-all duration-150" aria-label="I'm feeling lonely" data-id="element-29">
          <span className="text-3xl" role="img" aria-hidden="true" data-id="element-30">
            😔
          </span>
          <span className="font-medium text-foreground" data-id="element-31">Lonely</span>
        </button>

        <button onClick={() => onSelectTrigger('angry')} className="bg-card border border-border rounded-lg p-5 min-h-[88px] flex flex-col items-center justify-center gap-2 hover:border-primary/50 active:border-primary active:bg-highlight/20 transition-all duration-150" aria-label="I'm feeling angry" data-id="element-32">
          <span className="text-3xl" role="img" aria-hidden="true" data-id="element-33">
            😤
          </span>
          <span className="font-medium text-foreground" data-id="element-34">Angry</span>
        </button>

        <button onClick={() => onSelectTrigger('stressed')} className="bg-card border border-border rounded-lg p-5 min-h-[88px] flex flex-col items-center justify-center gap-2 hover:border-primary/50 active:border-primary active:bg-highlight/20 transition-all duration-150" aria-label="I'm feeling stressed" data-id="element-35">
          <span className="text-3xl" role="img" aria-hidden="true" data-id="element-36">
            😰
          </span>
          <span className="font-medium text-foreground" data-id="element-37">Stressed</span>
        </button>

        <button onClick={() => onSelectTrigger('tired')} className="bg-card border border-border rounded-lg p-5 min-h-[88px] flex flex-col items-center justify-center gap-2 hover:border-primary/50 active:border-primary active:bg-highlight/20 transition-all duration-150" aria-label="I'm feeling tired" data-id="element-38">
          <span className="text-3xl" role="img" aria-hidden="true" data-id="element-39">
            😴
          </span>
          <span className="font-medium text-foreground" data-id="element-40">Tired</span>
        </button>

        <button onClick={() => onSelectTrigger('other')} className="bg-card border border-border rounded-lg p-5 min-h-[88px] flex flex-col items-center justify-center gap-2 hover:border-primary/50 active:border-primary active:bg-highlight/20 transition-all duration-150" aria-label="I'm feeling something else" data-id="element-41">
          <span className="text-3xl" role="img" aria-hidden="true" data-id="element-42">
            ❓
          </span>
          <span className="font-medium text-foreground" data-id="element-43">Other</span>
        </button>
      </div>

      {/* Gentle reminder */}
      <p className="text-center text-sm text-muted-foreground mt-8 leading-relaxed" data-id="element-44">
        There's no wrong answer. Identifying what you feel is the first step.
      </p>
    </main>;
}